import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { SessionService } from '../services/session.service';

/** Matches API authorization for ADMIN and PracticeAdmin (Platform admin or practice admin). */
export const adminOrPracticeAdminGuard: CanActivateFn = async () => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  if (!sessionService.isSessionLoaded()) {
    try {
      await firstValueFrom(
        sessionService.checkSessionStatus().pipe(timeout(5000))
      );
    } catch {
      router.navigate(['/']);
      return false;
    }
  }

  if (sessionService.isAdmin() || sessionService.isPracticeAdmin()) {
    return true;
  }

  router.navigate(['/unauthorized']);
  return false;
};
